import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {HelperService} from "../helperService";
import * as Raven from "raven-js";


/**
 * Class > StartupService
 */
@Injectable()
export class StartupService
{


    /**
     * Function > constructor
     * @param {HttpClient} OBJ_http_client
     * @param {HelperService} OBJ_helper_service
     */
    constructor
    (
        private OBJ_http_client: HttpClient,
		private OBJ_helper_service: HelperService
    ) {} // end function constructor


    /**
     * Function > load
     * @param {string} STR_endpoint
     */
    load(STR_endpoint): Promise<any>
    {

		this.loadPatterns();

        let OBJ_promise = this.OBJ_http_client.get(STR_endpoint).toPromise();

		return OBJ_promise.then(
                (OBJ_config: any) => {

                    // get START config and replace placeholder
                    let OBJ_date = new Date();
                    OBJ_config.company = OBJ_config.company.replace("{{year}}", OBJ_date.getFullYear());
					this.OBJ_helper_service.setInLocalstorage('config', OBJ_config);

					// add google maps api script to <head>
					if (typeof OBJ_config.google_maps !== 'undefined') {
						const script = document.createElement('script');
						script.src = OBJ_config.google_maps;
						script.async = true;
						script.defer = true;
						document.head.appendChild(script);
					} // end if

                },
                (OBJ_error) => {
					Raven.captureException(OBJ_error);
                }
            );

    } // end function load

	loadPatterns(): void
	{

		let OBJ_promise = this.OBJ_http_client.get("./assets/patterns.json").toPromise();

		OBJ_promise.then(
			(OBJ_data: any) => {

				this.OBJ_helper_service.setPatterns(OBJ_data);
				this.OBJ_helper_service.logWithClassAndFunction(
					"StartupService",
					"loadPatterns",
					OBJ_data
				);

			},
			(OBJ_error) => {
				Raven.captureException(OBJ_error);
			}
		);

	}

} // end class StartupService
